/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_RoutinesInputs */

const en_tut_sc_routines = /** @type {(inputs: Tut_Sc_RoutinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to Routines`)
};

const id_tut_sc_routines = /** @type {(inputs: Tut_Sc_RoutinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Rutinitas`)
};

/**
* | output |
* | --- |
* | "Jump to Routines" |
*
* @param {Tut_Sc_RoutinesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_routines = /** @type {((inputs?: Tut_Sc_RoutinesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_RoutinesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_routines(inputs)
	return en_tut_sc_routines(inputs)
});